<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Poderi Boscarelli</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        La Toscana è famosa per molte cose: architettura gloriosa, dolci colline da cartolina, meraviglie gastronomiche e, naturalmente, vino più raffinato di quello che puoi bere. Mentre molte persone confondono la Toscana con il Chianti e viceversa, un vino che non può essere confuso è Poderi Boscarelli.
                    </div>

                    <div class="howto-title2">Il nome è Nobile... Vino Nobile</div>
                    <div class="howto-text">
                        Una piccola tenuta a conduzione familiare (appena 14 ettari); Eguido Corradi ha acquistato due piccoli semi abbandonati
                        aziende agricole a Cervognano di Montepulciano nei primi anni '60. Sebbene fosse un broker di mestiere, lui
                        fu anche un appassionato cultore di vini e studioso. Sapeva della fama che aveva il Vino Nobile
                        goduto nel 1900 e il suo obiettivo era renderlo di nuovo grande. La sua idea era quella di produrre vino “a
                        buona bottiglia di vino” per amici e parenti, tenendone 2.000 per sé.
                        <br><br>
                        Questo, tuttavia, non doveva essere. Egidio morì nel 1967, lasciando la tenuta alla figlia e al figlio
                        legge. Hanno continuato la sua visione e hanno rilasciato la prima bottiglia di Poderi Boscarelli Vino Nobile in
                        1968 (dalla vendemmia 1965). Seguì un decennio in cui la coppia avrebbe provato a vendere i propri vini
                        porta a porta ai ristoranti tra Genova e Montepulciano. Paracucchi a Firenze era d'accordo
                        per assaggiare i loro prodotti, lo servì al noto critico enologico Luigi Vernello che lo nominò poi uno dei
                        I 100 migliori vini d'Italia. E il resto, come si suol dire, è storia.
                    </div>

                    <div class="howto-title2">È un affare di famiglia</div>
                    <div class="howto-text">
                        Giunta alla terza generazione, l'azienda è gestita oggi dai due nipoti di Corradi, Luca e Nicolò.
                        Le uve Sangiovese sono il vitigno più diffuso, coprendo circa l'80% dei 14 ettari di
                        vigneti della tenuta. Il restante 20% è costituito da diverse varietà autoctone, tra cui
                        Mammolo, Canaiolo e Colorino, e vitigni internazionali come Merlot e Cabernet. Nel 2006
                        hanno piantato 2 ettari di Merlot nei vigneti della vicina Cortona. Sette rossi (più un dessert
                        vino così come l'onnipresente olio d'oliva), qui si produce solo il Vino Nobile di Montepulciano
                        Sotto Casa Riserva (2011) è il nostro consiglio. Premiato 93 da James Suckling nel 2016, il vino rimane
                        conveniente (aspettatevi di pagare meno di € 50 a bottiglia in Europa), ma ha il potenziale per un lungo invecchiamento
                        crescere e crescere. Aggiungilo alla scarsità del vino e avrai un'opportunità di investimento
                        sicuramente da considerare.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Poderi Boscarelli</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Die Toskana ist für viele Dinge berühmt: herrliche Architektur, malerische Hügel, gastronomische Wunder und natürlich mehr Wein, als man trinken kann. Während viele Menschen die Toskana mit Chianti verwechseln – und umgekehrt, ist Poderi Boscarelli ein Wein, mit dem man sich nicht verwechseln kann.
                    </div>

                    <div class="howto-title2">Der Name ist Nobile ... Vino Nobile</div>
                    <div class="howto-text">
                        Ein kleines, familiengeführtes Anwesen (nur 14 Hektar); Eguido Corradi kaufte zwei halb verlassene kleine
                        Bauernhöfe in Cervognano in Montepulciano in den frühen 1960er Jahren. Obwohl er von Beruf Makler war, war er
                        war auch ein begeisterter Weinliebhaber und Gelehrter. Er wusste um den Ruf, den Vino Nobile hatte
                        das im 20. Jahrhundert beliebt war, und sein Ziel war es, es wieder großartig zu machen. Seine Idee war es, Wein zu produzieren „a
                        „Eine gute Flasche Wein“ für Freunde und Familie und behielt 2.000 für sich.
                        <br><br>
                        Dies sollte jedoch nicht sein. Egidio starb 1967 und hinterließ das Anwesen seiner Tochter und seinem Sohn
                        Gesetz. Sie setzten seine Vision fort und brachten die erste Flasche Poderi Boscarelli Vino Nobile heraus
                        1968 (aus dem Jahrgang 1965). Es folgte ein Jahrzehnt, in dem das Paar versuchte, seine Weine zu verkaufen
                        Tür zu Tür zu den Restaurants zwischen Genua und Montepulciano. Paracucchi in Florenz stimmte zu
                        Um ihr Produkt zu probieren, servierte sie es dem bekannten Weinkritiker Luigi Vernello, der es dann als eines von ihnen bezeichnete
                        Italiens 100 erlesenste Weine. Und der Rest ist, wie man sagt, Geschichte.
                    </div>

                    <div class="howto-title2">Es ist eine Familienangelegenheit</div>
                    <div class="howto-text">
                        Das Weingut wird heute in der dritten Generation von Corradis beiden Enkeln Luca und Nicolo geführt.
                        Sangiovese-Trauben sind die am weitesten verbreitete Rebsorte und bedecken etwa 80 % der 14 Hektar
                        Weinberge im Anwesen. Die restlichen 20 % bestehen aus mehreren einheimischen Rebsorten, darunter
                        Mammolo, Canaiolo und Colorino sowie internationale Sorten wie Merlot und Cabernet. In 2006
                        Sie pflanzten 2 Hektar Merlot in Weinbergen im nahegelegenen Cortona an. Sieben Rotweine (plus ein Dessert
                        Wein sowie das allgegenwärtige Olivenöl) werden hier hergestellt, aber der Vino Nobile di Montepulciano
                        Sotto Casa Riserva (2011) ist unser Rat. Der Wein wurde 2016 von James Suckling mit 93 ausgezeichnet und bleibt bestehen
                        Erschwinglich (in Europa muss mit weniger als 50 € pro Flasche gerechnet werden), hat aber das Potenzial für eine lange Lagerung
                        wachsen und wachsen. Hinzu kommt die Knappheit des Weins, und Sie haben eine Investitionsmöglichkeit
                        auf jeden Fall eine Überlegung wert.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Poderi Boscarelli</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        La Toscane est célèbre pour beaucoup de choses : une architecture glorieuse, des collines vallonnées parfaites, des merveilles gastronomiques et bien sûr, plus de vins fins que vous ne pouvez en boire. Alors que beaucoup de gens confondent la Toscane avec le Chianti - et vice versa, un vin avec lequel vous ne pouvez pas vous tromper est Poderi Boscarelli.
                    </div>

                    <div class="howto-title2">Le nom est Nobile ... Vino Nobile</div>
                    <div class="howto-text">
                        Un petit domaine familial (seulement 14 hectares) ; Eguido Corradi a acheté deux petits semi-abandonnés
                        fermes à Cervognano de Montepulciano au début des années 1960. Bien qu'il fût courtier de métier, il
                        était aussi un ardent amateur de vin et un érudit. Il connaissait la réputation que Vino Nobile avait
                        apprécié dans les années 1900 et son objectif était de le rendre encore meilleur. Son idée était de produire du vin « un
                        bonne bouteille de vin » pour les amis et la famille, en gardant 2 000 pour lui.
                        <br><br>
                        Ceci, cependant, ne devait pas être. Egidio mourut en 1967, laissant le domaine à sa fille et son fils en
                        loi. Ils ont poursuivi sa vision et ont sorti la première bouteille de Poderi Boscarelli Vino Nobile en
                        1968 (du millésime 1965). Une décennie a suivi où le couple a essayé de vendre ses vins
                        porte à porte des restaurants entre Gênes et Montepulciano. Paracucchi à Florence a accepté
                        pour essayer leurs produits, l'a servi au célèbre critique de vin Luigi Vernello qui l'a alors nommé l'un des
                        Les 100 meilleurs vins fins d'Italie. Et le reste, comme on dit, c'est de l'histoire.
                    </div>

                    <div class="howto-title2">C'est une affaire de famille</div>
                    <div class="howto-text">
                        Désormais à sa troisième génération, le domaine est aujourd'hui dirigé par les deux petits-fils de Corradi, Luca et Nicolo.
                        Les raisins Sangiovese sont le cépage le plus répandu, couvrant environ 80% des 14 hectares de
                        vignes du domaine. Les 20 % restants sont constitués de plusieurs cépages indigènes, dont
                        Mammolo, Canaiolo et Colorino, et des variétés internationales comme le Merlot et le Cabernet. En 2006
                        ils ont planté 2 hectares de merlot dans des vignes à proximité de Cortona. Sept rouges (plus un dessert
                        vin ainsi que l'huile d'olive omniprésente), sont fabriqués ici mais le Vino Nobile di Montepulciano
                        Sotto Casa Riserva (2011) est notre conseil. Récompensé 93 par James Suckling en 2016, le vin reste
                        abordable (comptez moins de 50 € la bouteille en Europe), mais a le potentiel de longue garde
                        grandir et grandir. Ajoutez à cela la rareté du vin et vous avez une opportunité d'investissement
                        vaut vraiment la peine d'être considéré.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Poderi Boscarelli</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Tuscany is famous for many things: glorious architecture, picture-perfect rolling hills, gastronomic marvels and of course, more fine win than you can drink. While many people confuse Tuscany with Chianti – and vice versa, one wine that you cannot be mistaken by is Poderi Boscarelli.
                    </div>

                    <div class="howto-title2">The name’s Nobile ... Vino Nobile</div>
                    <div class="howto-text">
                        A tiny family-run estate (just 14- hectares); Eguido Corradi purchased two semi-abandoned small
                        farms in Cervognano of Montepulciano in the early 1960s. Although he was a broker by trade, he
                        was also an ardent wine lover and scholar. He knew of the reputation that Vino Nobile had
                        enjoyed in the 1900s and his aim was to make it great again. His idea was to produce wine “a
                        good bottle of wine” for friends and family, keeping 2,000 for himself.
                        <br><br>
                        This, however, was not to be. Egidio died in 1967, leaving the estate to his daughter and son in
                        law. They continued his vision and released the first bottle of Poderi Boscarelli Vino Nobile in
                        1968 (from the 1965 vintage). A decade followed where the couple would try and sell their wines
                        door to door to the restaurants between Genova and Montepulciano. Paracucchi in Florence agreed
                        to try their produce, served it to noted wine critic Luigi Vernello who then named it one of
                        Italy’s 100 top fine wines. And the rest, as they say, is history.
                    </div>

                    <div class="howto-title2">It’s a family affair</div>
                    <div class="howto-text">
                        Now in its third generation, the estate is run today by Corradi’s two grandsons Luca and Nicolo.
                        Sangiovese grapes are the most prevalent varietal, covering about 80% of the 14 hectares of
                        vineyards in the estate. The remaining 20% consists of several native varietals, including
                        Mammolo, Canaiolo and Colorino, and international varieties such as Merlot and Cabernet. In 2006
                        they planted 2 hectares of Merlot in vineyards in nearby Cortona. Seven reds (plus one dessert
                        wine as well as the ubiquitous olive oil), are made here but the Vino Nobile di Montepulciano
                        Sotto Casa Riserva (2011) is our advice. Awarded 93 by James Suckling in 2016, the wine remains
                        affordable (expect to pay less than €50 a bottle in Europe), but has the long-ageing potential
                        to grow and grow. Add that to the wine’s scarcity and you have an investment opportunity
                        definitely worth considering.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PoderiBoscarelli",
    head: {
        title: 'Poderi Boscarelli | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the excellence of Tuscany with Poderi Boscarelli wine producer. Immerse yourself in their rich heritage and experience the finest, handcrafted wines made from local grapes. Explore the premium quality and unique character of their wines today.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}
.wine-guide-left {
    width: 300px;
    display: inline-block;
}
.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}
.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}
.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}
.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
